import { getPdfSizes } from "helpers";
import { t } from "i18next";
import jsPDF from "jspdf";
import autoTable, { jsPDFDocument, Styles } from "jspdf-autotable";

import { OrderDetails } from "../../orders.types";
import { getDeliveryAndDriver } from "./getDeliveryAndDriver";

interface renderDeliveryAndDriverProps {
  pdf: jsPDF;
  orderDetails: OrderDetails;
  bigFontStyles: Partial<Styles>;
  normalFontStyles: Partial<Styles>;
}

export const renderDeliveryAndDriver = ({
  pdf,
  orderDetails,
  bigFontStyles,
  normalFontStyles
}: renderDeliveryAndDriverProps) => {
  const { pageWidth } = getPdfSizes(pdf);

  const { deliveryAddress, driverDetails } = getDeliveryAndDriver({
    orderDetails
  });

  autoTable(pdf, {
    theme: "plain",
    startY: (pdf as jsPDFDocument).lastAutoTable.finalY ?? 80,
    margin: 0,
    styles: {
      lineColor: "#000000",
      lineWidth: 1,
      cellPadding: 0
    },
    head: [
      [
        {
          content: `${t("DELIVERY ADDRESS")}:`,
          styles: {
            valign: "top",
            halign: "left",
            fillColor: "#ffffff",
            textColor: "#000000",
            ...normalFontStyles,
            lineWidth: { left: 1, right: 1, top: 1 },
            cellPadding: { horizontal: 5, top: 5, bottom: 5 }
          }
        },
        {
          content: `${t("DRIVER")}:`,
          styles: {
            valign: "top",
            halign: "left",
            fillColor: "#ffffff",
            textColor: "#000000",
            ...normalFontStyles,
            lineWidth: { left: 1, right: 1, top: 1 },
            cellPadding: { horizontal: 5, top: 5, bottom: 5 }
          }
        }
      ]
    ],
    body: [
      [
        {
          content: deliveryAddress,
          styles: {
            valign: "top",
            halign: "left",
            ...bigFontStyles,
            fontSize: 18,
            lineWidth: { left: 1, right: 1 },
            cellWidth: (pageWidth - 60) / 2,
            cellPadding: { horizontal: 5, vertical: 1 }
          }
        },
        {
          content: driverDetails,
          styles: {
            valign: "top",
            halign: "left",
            ...normalFontStyles,
            lineWidth: { left: 1, right: 1 },
            cellWidth: (pageWidth - 60) / 2,
            cellPadding: { horizontal: 5, vertical: 1 }
          }
        }
      ]
    ]
  });
};
